"use client"
import o from"@r2wc/react-to-web-component";import{YourTeam as e}from"@percy.ai/ui";var r=o(e,{props:{header:"string",team:"json",socialNetworksColor:"string"}});customElements&&customElements.define("your-team",r);
//# sourceMappingURL=your-team.js.map